import React from 'react';
import styled from 'styled-components';
import { Typography, Card, CardContent } from '@material-ui/core';

import { Colors } from 'typings';

const UnsupportedBrowserWrapper = styled('div')`
  background-color: ${(props) => props.theme.palette.primary.main};
  width: 100%;
  height: 100vh;
  display: flex;
  align-items: center;
`;

const UnsupportedBrowserCard = styled(Card)`
  margin: 0 auto;
  padding: ${(props) => props.theme.spacing(15)};
  background-color: ${Colors.WHITE};
  color: ${Colors.BLACK};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
`;

const UnsupportedBrowser = () => {
  return (
    <UnsupportedBrowserWrapper>
      <UnsupportedBrowserCard raised>
        <CardContent>
          <Typography variant="h5">Hello!</Typography>
          <Typography variant="subtitle2">
            This Browser is not supported. Please use Chrome
          </Typography>
        </CardContent>
      </UnsupportedBrowserCard>
    </UnsupportedBrowserWrapper>
  );
};

export default UnsupportedBrowser;
